// US phone number https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s02.html
export const phoneRegex = new RegExp(/^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/);